<template>
	<div class="plane-problem":class="{'isiOSX':isiOSX}">
		<van-nav-bar
			
		  title="常见问题"
		  left-arrow
		  @click-left="goBack"
		/>
		<div class="problem-content">
		  	<van-row class="recommend">
			  	<van-col class="title" span="24">
			  		<span class="border"></span>小巴服务
			  	</van-col>
			  	<van-col span="6" v-for="(item, index) in list" :key="index" v-if="item.is_recommended == 1">
			  		<div @click="goToSeeDetail(item.id)">
			  			<img :src="item.icon" @error="defaultPro()"/>
			  			<p>{{item.issue}}</p>
			  		</div>
			  	</van-col>
			</van-row>
			<van-row class="common">
				<van-col class="title" span="24">
			  		<span class="border"></span>常见问题
			  	</van-col>
			</van-row>
			<div class="problem-list">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="list.length != 0">
					<van-list
					  v-model="loading"
					  :finished="finished"
					  finished-text="没有更多了"
					  @load="onLoad"
					>
					  <div v-for="(item, index) in list" :key="index" v-if="item.is_recommended == -1">
					  	<p @click="goToSeeDetail(item.id)">{{item.issue}}</p>
					  </div>
					</van-list>
				</van-pull-refresh>
			</div>
		</div>
		<van-goods-action>
			<van-button size="large" class="service" @click="onlineService()">在线服务</van-button>
		</van-goods-action>
		<p class="tip">求助智能机器人、客服小巴，获得更多解答</p>
		
	</div>
</template>

<script>
import productDefault from '@/assets/common/preload.png';
export default {
  data() {
    return {
      	list: [],
      	loading: false,
      	finished: false,
      	isLoading: false,
        page: 1,
        pageSize: 10,
        allList: 21, //默认比第一页数据多1
        isiOSX: false
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
　　	this.getInfo()
  },
  methods: {
  	onLoad() {
      // 异步更新数据
      setTimeout(() => {
      	this.page ++;
      	this.getInfo();
	      	
        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
		this.page = 1;
		this.finished = false;
    	this.list = [];
	    this.getInfo();
    },
    goBack() {
    	if(this.$route.query.module == 'hotel') {
    		this.params('', '', 'goBack');
    	}else {
    		this.$router.go(-1);
    	}
    	
    },
    goToSeeDetail(currentId) {
    	this.$router.push({
	      path: "/problem/answer",
	      query: {
	        id: currentId
	      }
    	});
    },
    getInfo() {
    	this.$api.post("/setting/index/common/problems/list",{module:this.$route.query.module,pageSize: this.pageSize, page: this.page}).then(res => {
	        this.allList = res.total;
	        if(res.list.length > 0) {
	        	for(let i in res.list) {
		        	this.list.push(res.list[i]);
		        }
	        }
			this.loading = false;
	        if (this.list.length >= this.allList) {// 数据全部加载完成
	          this.finished = true;
	        }
	        if(this.isLoading) {
	        	this.$toast('刷新成功');
        		this.isLoading = false;
	        }
	    });
    },
    onlineService() {
    	this.params('', '', 'onlineService');
    },
    defaultPro() {
	  	var img = event.srcElement;
		img.src = productDefault;
		img.onerror = null; //防止闪图
	}
  }
};
</script>

<style lang="less">
.plane-problem {
	height: 100%;
	background: #f2f2f2;
	.van-nav-bar {
  		background: #F2F2F2;
  		padding-top: 24px;
  		position: fixed;
    	width: 100%;
  		.van-nav-bar__title {
  			font-size: 18px;
  			color: #333;
  		}
  		.van-nav-bar__text {
  			color: #333;
  			font-size: 14px;
  		}
  		.van-icon-arrow-left:before {
  			display: none;
  		}
  		.van-nav-bar__left {
  			left: 11px;
  			.van-icon {
  				width: 17px;
  				height: 15px;
  				display: inline-block;
  				background: url(../../assets/plane/reBack.png) no-repeat center center;
  				background-size: 100% 100%;
  			}
  		}
  	}
  	.problem-content {
  		padding-top: 70px;
		.recommend {
			background: #fff;
			padding-bottom: 25px;
			/*padding-top: 70px;*/
			margin-bottom: 7px;
			box-shadow: #E3E3E3 2px 0 4px;
			.title {
				color: #333;
				font-size: 13px;
				font-weight: bold;
				padding: 21px 11px;
				.border {
					width: 2px;
					height: 12px;
					background: #ED6161;
					display: inline-block;
					margin-right: 6px;
				}
			}
			.van-col--6 {
				text-align: center;
				color: #333;
				font-size: 13px;
				img {
					width: 40px;
				}
			}
		}
		.common {
			background: #fff;
			box-shadow: #E3E3E3 2px 0 4px;
			padding: 0 11px;
			.title {
				color: #333;
				font-size: 13px;
				font-weight: bold;
				padding: 22px 0 10px;
				.border {
					width: 2px;
					height: 12px;
					background: #1B99F2;
					display: inline-block;
					margin-right: 7px;
				}
			}
		}
		.problem-list {
			height: 100%;
		    overflow-y: scroll;
		    -webkit-overflow-scrolling:touch;
			.van-pull-refresh{
				padding: 0 11px;
				margin-bottom: 73px;
				background: #fff;
				p{
					height: 34px;
					line-height: 34px;
					font-size: 13px;
					padding: 0 7px;
					border-top: solid 1px #F2F2F2;
				}
			}
		}
	}
	.service {
		background: #fff;
		color: #1B99F2;
		font-size: 14px;
		border: none;
		height: 42px;
		line-height: 42px;
		box-shadow: #E3E3E3 2px 0 4px;
	}
	.van-goods-action {
		bottom: 31px;
	}
	.tip {
		color: #999;
		font-size: 10px !important;
		left: 0;
	    right: 0;
	    bottom: 0;
	    display: block;
	    position: fixed;
	    height: 31px;
	    line-height: 31px;
	    background: #F2F2F2;
	    text-align: center;
	}
}

.isiOSX {
	.van-nav-bar{
		padding-top: 44px;
	}
	.problem-content {
  		padding-top: 90px;
  	}
}
</style>
